export default __webpack_public_path__ + "img/apple-touch-icon.b80f1a45.png";